export enum SuggestionType {
  URI = 'uri',
  PREFIX = 'prefix',
}
